var _style, _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFile16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.icon-file-st0{opacity: .75;}\n\t.icon-file-st1{opacity:0;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "icon-file-st0",
    d: "M13.29,4.132H9.859V0.71H9.16v3.772c0,0.193,0.156,0.35,0.35,0.35h3.781V4.132z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.83,4.424c0-0.064-0.025-0.126-0.071-0.171L9.749,0.203C9.703,0.157,9.641,0.131,9.576,0.131H3.497 c-0.193,0-0.35,0.157-0.35,0.35v0.977v0.448v13.651c-0.001,0.094,0.036,0.183,0.102,0.248c0.066,0.066,0.155,0.091,0.248,0.091 h9.985c0.093,0,0.182-0.036,0.248-0.103c0.065-0.065,0.103-0.154,0.102-0.248L13.83,4.424z M13.131,15.208H3.894V1.906V1.458V0.831 l5.384,0.002c0.06,0,0.118,0.024,0.161,0.067l3.632,3.657c0.042,0.043,0.066,0.1,0.066,0.16L13.131,15.208z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "icon-file-st1",
    width: 16,
    height: 16
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFile16);
export default __webpack_public_path__ + "static/media/icon-file-16.299db222c7aee3d1debd0d69f4cefa9e.svg";
export { ForwardRef as ReactComponent };